import { forOwn, set } from 'lodash';
import { getOrgaDateFuerAntrag } from 'src/utils/orgaDatenhelper';
import { ANTRAG_TYP, ANTRAGS_FORMULAREN, ANTRAGS_STATUS, ART_DES_ANTRAGS, VORHABENS_ART } from '../../../../../lib/constants/constant';
import { isOrgaAbteilungEinerHochschule, isTrue, removeIdsFromArrayObjects } from '../../../../../utils/helper';

// import schemas
import { get, isArray } from 'lodash';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS } from 'src/lib/constants/componentsPath';
// import FoerderProgrammSchema from '../../../../../lib/paths/foerderprogramm_FULL_Paths.json';
// import AntragSchema from '../../../../../lib/paths/antrag_FULL_Paths.json';
// import OrganisationSchema from '../../../../../lib/paths/organisation_FULL_Paths.json';
// const ORGA_P = OrganisationSchema.attributes;
// const FP_P = FoerderProgrammSchema.attributes;
// const A_P = AntragSchema.attributes;

/**
 * *************************************** ZUERST LESEN ***************************************
 * **************************************** ATTENTION *****************************************
 * ATTENTION: This function is used in another components like Startup-Stipendium-Dashboard.
 * Used in LogMobFoerderDashboard.tsx and StartupStipendiumFoerderDashboard.tsx
 * WHILE CHANGING ALSO TEST IT IN ANOTHER COMPONENTS
 * *************************************** --------- ***************************************
 * This funciton has all the general app or some default values which is needed while creating a skizze or Antrag.
 * @param programmData | Förderprogramm Details
 * @param programmID | Förderprogramm ID
 * @param antragsformular | STRING: Antragformular
 * @param antragsTyp | Antragstyp
 * @param orgaData | Organisation Details
 * @param loggedInOrgaID | Organisation-ID
 * @returns | Returns the general app data which a Antrag always needs
 */
export function getGeneralAppData(
	programmData: any,
	programmID: number,
	antragsformular: string,
	antragsTyp: string,
	orgaData: any,
	loggedInOrgaID: number,
	alleAntragberechtigte?: any,
	artDesAntrags?: string | undefined,
) {
	const isFormantrag = artDesAntrags === ART_DES_ANTRAGS.Formantrag;
	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Formantrag
		: FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_PATHS.Antrag;

	const pflichtErklaerung = get(programmData, paths.PflichtErklaerungen, []);
	const optionaleErklaerung = get(programmData, paths.OptionaleErklaerungen, []);
	const erforderlicheAnlagen = get(programmData, paths.PflichtAnlagen, []);
	const optionaleAnlagen = get(programmData, paths.OptionaleAnlagen, []);

	const isOrgaAbteilungHochschule = isOrgaAbteilungEinerHochschule(orgaData);

	let generalAppData = {
		Foerderprogramm: programmID,
		Allgemein_Antragsformular: antragsformular,
		Allgemein_Art_Des_Antrags: 'Erstantrag',
		Allgemein_Typ: antragsTyp,
		Antragstatus_Antragstatus: ANTRAGS_STATUS.inBearbeitung,
		Allgemein_Vorhabensart: VORHABENS_ART.Einzelvorhaben,

		// Organisation Details
		Antragstellende_Organisation: loggedInOrgaID,
		Antragstellende_Organisation_Ansprechpartnerin: [{ Vorname: '' }],

		// Selbst Erklärung-KMU
		Selbsterklaerung_KMU: [
			{ Kmu_Unternehmen: loggedInOrgaID, Kmu_Kennzahlen: [{ Kmu_Kennzahlen_Bezugsjahr: null }, { Kmu_Kennzahlen_Bezugsjahr: null }] },
		],
		// Selbsterklärung RUS
		Selbsterklaerung_RUS: [{ Unternehmen: loggedInOrgaID }],
		// Selbsterklärung Beihilferelevanz
		Beihilferelevanz_Selbsterklaerung: [{ Unternehmen: loggedInOrgaID }],
		// Deminimis
		Deminimis_Bereits_Erhaltene_Beihilfen: [{ Unternehmen: '' }],
		Deminimis_Bereits_Beantragte_Beihilfen: [{ Unternehmen: '' }],
		Deminimis_Kombination: [{ Unternehmen: '' }],
		// erste Zeitplanung
		Zeitplanung_Zeitplanung_Block_1: getZeitplanung(antragsformular),

		// Erklärungen
		Erklaerungen_Pflichterklaerungen: removeIdsFromArrayObjects(pflichtErklaerung),
		Erklaerungen_Optionale_Erklaerungen: removeIdsFromArrayObjects(optionaleErklaerung),

		// Anlagen
		Anlagen_Erforderliche_Anlagen: removeIdsFromArrayObjects(erforderlicheAnlagen),
		Anlagen_Optionale_Anlagen: removeIdsFromArrayObjects(optionaleAnlagen),
		Anlagen_Sonstige_Anlagen: [{ Bezeichnung_Des_Dokuments: '' }],
	};

	if (isTrue(isOrgaAbteilungHochschule)) {
		if (isArray(alleAntragberechtigte) && alleAntragberechtigte.length > 0) {
			const antragsberechtigteID = get(alleAntragberechtigte, '[0].id', null);

			if (Number(antragsberechtigteID)) {
				set(generalAppData, 'Organisation_Antragsberechtigt_Als', antragsberechtigteID);
			}
		}
	}

	const orgaDataFuerAntrag = getOrgaDateFuerAntrag(orgaData);
	// This lodash function loops throug a JSON.
	// The parmeter for the callback-function are (value, key)
	forOwn(orgaDataFuerAntrag, (value: string, key: string) => {
		set(generalAppData, key, value);
	});

	return generalAppData;
}

const getZeitplanung = (antragsFormular: string) => {
	switch (antragsFormular) {
		case ANTRAGS_FORMULAREN.EmobLis:
			return [
				{ Zelle_1: 'Ausschreibung' },
				{ Zelle_1: 'Vergabe' },
				{ Zelle_1: 'Beauftragung' },
				{ Zelle_1: 'Lieferung' },
				{ Zelle_1: 'Baumaßnahmen' },
				{ Zelle_1: 'Inbetriebnahme' },
			];
		case ANTRAGS_FORMULAREN.Loewe:
			// const Group_id = uuidv4().replace(/-/g, '').slice(0, 12); // 12-stellige Group_id ohne Bindestriche
			return [{ Zelle_6: 'Aufgabe' }];
		default:
			return [{ Zelle_1: '' }];
	}
};
